import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable';
import { filter, ignoreElements, tap, withLatestFrom } from 'rxjs/operators';
import { scroller } from 'react-scroll';
// constants
import {
    EMBEDDED_CONTENT_SCROLL_ELEMENT,
    SCROLL_TOP_X,
    SCROLL_TOP_Y,
    SUB_CONTENT_SCROLL_ELEMENT
} from 'components/content/content.constants';
import { WEBSITES_FLOW_ID_BY_WIDGET_NAME } from '@sitegen/common/constants/website';
import { Constants as RouterConstants } from 'modules/router';
// types
import IConfig from '@sitegen/common/constants/config';
import { IAction } from 'types/action';
import { IEpic } from 'types/epic';
// utils
import { getModeClass, isEmbedded } from 'utils/css';
import { isRedeem } from '@sitegen/common/utils/flow-type';

const scrollTo = (element: string | null) => {
    return element ? scroller.scrollTo(element, {}) : window.scrollTo(SCROLL_TOP_X, SCROLL_TOP_Y);
};

export const changeView: IEpic = (action$: ActionsObservable<IAction>, state$: StateObservable<{ config: IConfig, hasFocus: boolean }>) => {
    const flowId = WEBSITES_FLOW_ID_BY_WIDGET_NAME[state$.value.config.widgetName];
    const isEmbeddedMode = isEmbedded(state$.value.config.mode);
    const scrollElementClass = getModeClass(EMBEDDED_CONTENT_SCROLL_ELEMENT, state$.value.config.shouldInheritStyles);
    const scrollElement =  isEmbeddedMode ?
        scrollElementClass
        : isRedeem(flowId) ?
            SUB_CONTENT_SCROLL_ELEMENT
            : null;

    return action$.ofType(RouterConstants.WIDGET_ACTIVE_VIEW_TRANSITION).pipe(
        withLatestFrom(state$),
        filter(([_ , state]) => state.hasFocus ),
        tap(() => scrollTo(scrollElement)),
        ignoreElements()
    );
};

export default combineEpics(changeView);
